import { useEffect, useState } from "react";

// Ícone calculadora da consulta_producao TELA-1: calculadora simples em modal (pt-BR, vírgula decimal).
export function Calculadora({ onFechar }: { onFechar: () => void }) {
  const [visor, setVisor] = useState("0");
  const [acum, setAcum] = useState<number | null>(null);
  const [op, setOp] = useState<string | null>(null);
  const [novo, setNovo] = useState(true);

  const num = (s: string) => Number(s.replace(/\./g, "").replace(",", ".")) || 0;
  const fmt = (n: number) =>
    Number.isFinite(n) ? new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 10 }).format(n) : "Erro";
  const calc = (a: number, b: number, o: string) => (o === "+" ? a + b : o === "-" ? a - b : o === "*" ? a * b : b === 0 ? NaN : a / b);

  function digito(d: string) {
    if (d === ",") {
      if (novo) return (setVisor("0,"), setNovo(false));
      if (!visor.includes(",")) setVisor(visor + ",");
      return;
    }
    if (novo || visor === "0") setVisor(d);
    else setVisor(visor + d);
    setNovo(false);
  }
  function operador(o: string) {
    const v = num(visor);
    if (acum != null && op && !novo) {
      const r = calc(acum, v, op);
      setAcum(r);
      setVisor(fmt(r));
    } else setAcum(v);
    setOp(o);
    setNovo(true);
  }
  function igual() {
    if (acum == null || !op) return;
    const r = calc(acum, num(visor), op);
    setVisor(fmt(r));
    setAcum(null);
    setOp(null);
    setNovo(true);
  }
  function limpar() {
    setVisor("0");
    setAcum(null);
    setOp(null);
    setNovo(true);
  }

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (/^[0-9]$/.test(e.key)) digito(e.key);
      else if (e.key === "," || e.key === ".") digito(",");
      else if (["+", "-", "*", "/"].includes(e.key)) operador(e.key);
      else if (e.key === "Enter" || e.key === "=") {
        e.preventDefault();
        igual();
      } else if (e.key === "Escape") onFechar();
      else if (e.key === "Backspace") setVisor((v) => (v.length > 1 ? v.slice(0, -1) : "0"));
      else return;
      e.stopPropagation();
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  });

  const teclas = ["7", "8", "9", "/", "4", "5", "6", "*", "1", "2", "3", "-", "0", ",", "=", "+"];
  return (
    <div className="pcf-modal-bg" onClick={onFechar}>
      <div className="pcf-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pcf-modal-topo">
          <b>Calculadora</b>
          <button className="btn-secundario" onClick={onFechar}>Fechar</button>
        </div>
        <div style={{ width: 300, maxWidth: "100%", margin: "0 auto" }}>
        <input className="num" readOnly value={visor} style={{ width: "100%", boxSizing: "border-box", fontSize: 22, textAlign: "right", marginBottom: 8 }} />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 6 }}>
          {teclas.map((t) => (
            <button
              key={t}
              className={/[0-9,]/.test(t) ? "btn-secundario" : "btn-acao"}
              style={{ minWidth: 0, padding: "10px 0", fontSize: 18 }}
              onClick={() => (t === "=" ? igual() : /[0-9,]/.test(t) ? digito(t) : operador(t))}
            >
              {t === "*" ? "×" : t === "/" ? "÷" : t}
            </button>
          ))}
          <button className="btn-secundario" style={{ gridColumn: "span 4", minWidth: 0 }} onClick={limpar}>
            C
          </button>
        </div>
        </div>
      </div>
    </div>
  );
}
